import axios from 'axios';
import authHeader from "@/service/auth-header";

class BankAccountService {

    async getBankAccountsForCompany(companyId) {
        return await axios.get(`/api/bankaccount/company/${companyId}`, {headers: authHeader()})
    }

    async getBankAccountsForUser(userId) {
        return await axios.get(`/api/bankaccount/user/${userId}`, {headers: authHeader()})
    }

    async createBankAccount(companyId, data) {
        return await axios.post(`/api/bankaccount/${companyId}`, data, {headers: authHeader()});
    }

    async updateBankAccount(bankAccountId, data) {
        return await axios.put(`/api/bankaccount/${bankAccountId}`, data, {headers: authHeader()});
    }

    async deleteBankAccount(bankAccountId) {
        return await axios.delete(`/api/bankaccount/${bankAccountId}`, {headers: authHeader()})
    }

    searchCompanyBankAccounts(companyId, searchCriteria) {
        console.log("[BankAccountService][searchCompanyBankAccounts] Before getting bank accounts. Company ID = ", companyId);
        return axios.get(`/api/bankaccount/${companyId}/${searchCriteria}`, {headers: authHeader()})
    }

}

export default new BankAccountService();
